import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.07 7.37L12.52 6L18 11.75L12.52 17.5L11.07 16.13L15.24 11.75L11.07 7.37ZM7.45 6L6 7.37L10.17 11.75L6 16.13L7.45 17.5L12.93 11.75L7.45 6Z" fill={ fill || 'currentColor' } />
    </svg>
);
